import React from 'react'
import styles from './ProjectsList.module.css'
import Project from './Project/Project';
import { ProjectInterface } from '../../../lib/types/project';

export interface ProjectsListProps {
    projects: ProjectInterface[];
    setProjectTitle: React.Dispatch<React.SetStateAction<string>>;
    setHoverProject: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProjectsList = (props: ProjectsListProps) => {

    return (
        <div className={styles.container}>
            {props.projects.map((data, index) => (
                <Project setProjectTitle={props.setProjectTitle} setHoverProject={props.setHoverProject} key={data.titleUrl} project={data} index={index} />
            ))}
        </div>
    )
}

export default ProjectsList
